import React, { Component } from 'react';

export default class BatchNotice extends Component {
  render () {
    const { title = '', content = {} } = this.props;
    const { totalCount = 0, successCount = 0, failCount = 0, data: { messages = [] } = {} } = content;
    return <div>
      <div>
        <span>{ lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8002E', '共') }{ title }</span>
        <span>{ `(${totalCount})` }</span>
        <span>{ lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8002F', '条，成功') }</span>
        <span style={{ color: '#18b681'}}>{ `(${successCount})` }</span>
        <span>{ lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80030', '条，失败') }</span>
        <span style={{ color: '#ee2223'}}>{ `(${failCount})` }</span>
        <span>{ lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80031', '条') }</span>
      </div>
      {
        messages && (<ul>{ messages.map((message: string) => <li>{ message }</li>) }</ul>) 
      }
    </div>
  }
}
